/******************************************************************************\
 * :$
 *
 * Copyright(c) 2022 SAS Institute Inc., Cary, NC, USA. All Rights Reserved.
 *
 * Name: ConfirmDialog
 *
 * Purpose:
 *
 * Author: craig (Craig.Simpson@sas.com)
 *
 * Support: SAS(r) Solutions OnDemand
 *
 * Input:
 *
 * Output:
 *
 * Parameters: (if applicable)
 *
 * Dependencies/Assumptions:
 *
 * Usage:
 *
 * History:
 * ddmmmyyyy userid description (Change Code)
 * 17Oct2022 craig File created.
 \******************************************************************************/
import React from "react";
import {Button, Modal} from "react-bootstrap";

interface ConfirmDialogProps {
    title:string,
    body: React.ReactNode,
    show:boolean,
    showHide:any,
    submitForm:any
}

export const ConfirmDialog: React.FC<ConfirmDialogProps> = ({title, body, show, showHide, submitForm}: ConfirmDialogProps) => {
    return (
        <Modal key={"confirm-dialog"} show={show} onHide={showHide} centered>
            <Modal.Header closeButton={true}>
                <Modal.Title>Submit Review</Modal.Title>
            </Modal.Header>
            <Modal.Body>{body}</Modal.Body>
            <Modal.Footer>
                <Button variant={"secondary"} onClick={showHide}>
                    Close
                </Button>
                <Button variant={"primary"} onClick={submitForm}>
                    Submit
                </Button>
            </Modal.Footer>
        </Modal>
    )
}